import React from 'react';

// onboarding screens
import EmailVerification from '_scenes/onboarding/email-verification';
import PasswordReset from '_scenes/onboarding/password-reset';
import MfaSetup from '_scenes/onboarding/mfa-setup';

/**
 * Renders the onboarding step the user needs to complete.
 * The step is computed by the root router from the user's custom claims:
 * email verification -> temporary password change -> MFA enrollment.
 */
const OnboardingRouter = ({ step }) => {
  switch (step) {
    case 'email-verification':
      return <EmailVerification />;
    case 'password-reset':
      return <PasswordReset />;
    case 'mfa-setup':
      return <MfaSetup />;
    default:
      return null;
  }
};

export default OnboardingRouter;
